const setNestedKey = (obj: any, path: string[], value: any) => {
    // this method set an object value with a dynamic made key
    if (path.length === 1) {
        obj[path[0]] = value;
        return;
    }

    if (obj[path[0]] === undefined) obj[path[0]] = {};
    setNestedKey(obj[path[0]], path.slice(1), value);
};

export { setNestedKey };
